import './App.css'
import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import LandingPage from './LandingPage'
import SignIn from './components/Auth/SignIn'
import SignUp from './components/Auth/SignUp'
import Dashboard from './Dashboard'
import BuilderApp from './BuilderApp'
import DNSInstructions from './components/DNSInstructions/DNSInstructions'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/editor/:siteId" element={<BuilderApp />} />
        <Route path="/dns-instructions/:siteId" element={<DNSInstructions />} />
      </Routes>
    </Router>
  )
}

export default App